export enum DefaultLabels {
  ADDING_TO_BAG = 'Adding to bag...',
  ADD_TO_BAG = 'Add to Bag',
  OUT_OF_STOCK = 'Out of Stock',
  REMIND_ME = 'Remind Me',
  WAITLISTED = 'Waitlisted',
  WAITLISTING = 'Adding to waitlist...',
  WAITLIST_ME = 'Waitlist Me',
}
